// Node
import * as sortBy from 'lodash/sortBy';
import { difference } from 'underscore';
// Common
import FunnySadDialog from 'new_design/common/funny-sad-dialog';
import CampListSeparator from './camp_list_separator';
import CampListLoadingDesktop from './filter_desktop/camp_list_loading.js';
import CampListTransferDesktop from './filter_desktop/camp_list_transfer_desktop.js';
import { IS_MIRTURBAZ, IS_SANATORIUMS, IS_UBOOK } from './filter_main.js';
import CampListLoadingMobile from './filter_mobile/camp_list_loading.js';
import CampListTransferMobile from './filter_mobile/camp_list_transfer_mobile.js';
import Pagination from './filter_mobile/pagination.js';

const $ = require('jquery');
require('jquery.cookie');

export default class CampsListMain extends React.Component {
  constructor(props) {
    super(props);
    this._loadApartments = this._loadApartments.bind(this);
    this._campIds = this._campIds.bind(this);
    this._getInitCamp = this._getInitCamp.bind(this);
    this._getLazyCamp = this._getLazyCamp.bind(this);
    this._renderCampCard = this._renderCampCard.bind(this);
    this._nearbySeparatorText = this._nearbySeparatorText.bind(this);

    this.state = {
      camps_with_apartments: [],
      loaded_ids: [],
    };
    this.numberOfCampsRequiredToShowMidAds = 4;
  }

  componentDidMount() {
    if (this.props.camps[0]?.apartments?.length > 0) {
      this.setState({ camps_with_apartments: this.props.camps });
    } else {
      this._loadApartments(difference(this._campIds(), this.state.loaded_ids));
    }
  }

  // Находит разницу между сохраненными и новыми ОР, загружаем новые
  componentDidUpdate(prev_props) {
    //this._loadApartments(difference(this._campIds(), this.state.loaded_ids)); Deprecated
  }

  // Загружает апартаменты для указанных ОР
  _loadApartments(ids_to_load) {
    if (ids_to_load.length === 0) return;

    let isForFewerCapacity = this.props.camps.find((camp) => camp.id === ids_to_load[0])?.withLessCapacity;
    let url = `${window.website_prefix}/filter/load_apartments.json?camp_ids=${ids_to_load}`;
    if (isForFewerCapacity) {
      let search_data = JSON.parse($.cookie('search_data'));
      search_data.count_guests = this.props.fewerCountGuests();
      search_data.without_cookies = true;
      url += `&${new URLSearchParams(search_data).toString()}`;
    }

    this.state.loaded_ids = [...this.state.loaded_ids, ...ids_to_load];
    fetch(url)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState((state) => {
          return {
            camps_with_apartments: { ...state.camps_with_apartments, ...data.camps },
          };
        });
      })
      .catch(() => {
        FunnySadDialog.createSadDialog(
          'Не удалось загрузить список апартаментов',
          'Проверьте работоспособность интернет-соединения, либо попробуйте ещё раз через несколько минут.'
        );
      });
  }

  _getLazyCamp(id) {
    return this.state.camps_with_apartments[id];
  }

  // Создает список id ОР для текущей страницы
  _campIds() {
    return this.props.camps.map((c) => c.id);
  }

  _getInitCamp(id) {
    return this.state.camps.find((c) => c.id == id);
  }

  _nearbySeparatorText() {
    if (IS_SANATORIUMS) {
      return 'Другие санатории поблизости';
    }

    if (IS_UBOOK) {
      return 'Другие отели поблизости';
    }

    return 'Другие базы отдыха поблизости';
  }

  render() {
    let campList;

    if (this.props.showAllCamps) {
      let favoriteCamps = this.props.camps.map(this._renderCampCard);
      favoriteCamps = sortBy(favoriteCamps, (camp) => !camp.props.apartments?.length > 0);
      campList = <div className='cards favorite-cards'>{favoriteCamps.slice(0, this.props.visibleFavoriteCamps)}</div>;
    } else {
      const mainCamps = this.props.camps;
      const firstPart = mainCamps.slice(0, 2).map(this._renderCampCard);
      const secondPart = mainCamps.slice(2, 4).map(this._renderCampCard);

      let transferBlock;
      if (this.props.show_transfer) {
        if (window.isMobileDevice) {
          transferBlock = <CampListTransferMobile />;
        } else {
          transferBlock = <CampListTransferDesktop />;
        }
      }

      let adsBlock;
      if (IS_MIRTURBAZ) {
        adsBlock = this._renderAd();
      }

      const thirdPart = mainCamps.slice(4).map(this._renderCampCard);

      const nearbyCamps = this.props.nearbyCamps || [];
      let withGreaterDistancePart = null;
      let withGreaterDistanceSeparator = null;
      let nearbyLoader = null;

      if (nearbyCamps.length > 0) {
        withGreaterDistancePart = nearbyCamps.map(this._renderCampCard);
        withGreaterDistanceSeparator = <CampListSeparator text={this._nearbySeparatorText()} />;
      }

      if (this.props.nearbyLoading) {
        nearbyLoader = window.isMobileDevice ? (
          <CampListLoadingMobile camps_count={5} />
        ) : (
          <CampListLoadingDesktop camps_count={5} />
        );
      }

      campList = (
        <div className='cards'>
          {firstPart}
          {transferBlock}
          {secondPart}
          {adsBlock}
          {thirdPart}
          {withGreaterDistanceSeparator}
          {withGreaterDistancePart}
          {nearbyLoader}
          {nearbyCamps.length > 0 &&
            !this.props.nearbyLastPageLoaded &&
            !this.props.nearbyLoading &&
            (window.isMobileDevice ? (
              <Pagination loadMore={() => this.props.loadMore('nearby')} />
            ) : (
              <div className={'pagination__item'} onClick={() => this.props.loadMore('nearby')}>
                Показать еще
              </div>
            ))}
        </div>
      );
    }

    return campList;
  }
}
